import React from 'react';
import { FaShieldAlt, FaChartLine, FaHandshake, FaHeadset } from 'react-icons/fa';
import { motion } from 'framer-motion';

const features = [
    {
        name: 'Minh Bạch Pháp Lý',
        description: 'Tất cả thông tin bất động sản đều được xác thực và minh bạch về pháp lý.',
        icon: FaShieldAlt,
        color: 'text-green-500',
    },
    {
        name: 'Đánh Giá Chuyên Sâu',
        description: 'Phân tích thị trường chi tiết, giúp bạn đưa ra quyết định đầu tư chính xác.',
        icon: FaChartLine,
        color: 'text-blue-500',
    },
    {
        name: 'Hỗ Trợ Giao Dịch',
        description: 'Đội ngũ môi giới chuyên nghiệp đồng hành từ A đến Z, đảm bảo giao dịch suôn sẻ.',
        icon: FaHandshake,
        color: 'text-amber-500',
    },
    {
        name: 'Hỗ Trợ 24/7',
        description: 'Hỗ trợ khách hàng mọi lúc, mọi nơi, giải đáp mọi thắc mắc nhanh chóng.',
        icon: FaHeadset,
        color: 'text-red-500',
    },
];

const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } },
};

const ServiceHighlights = () => {
    return (
        <section className="py-16 bg-gray-100">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                {/* Tiêu đề */}
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.5 }}
                    className="text-center mb-12"
                >
                    <h2 className="text-3xl font-extrabold text-[#0c2c4d] sm:text-4xl">
                        Vì sao nên chọn <span className="text-[#c9a063]">Dịch vụ của chúng tôi ?</span>
                    </h2>
                </motion.div>

                {/* Danh sách Ưu điểm */}
                <motion.div
                    className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.3 }}
                    variants={{
                        visible: {
                            transition: {
                                staggerChildren: 0.2,
                            },
                        },
                    }}
                >
                    {features.map((feature, index) => {
                        const Icon = feature.icon;
                        return (
                            <motion.div
                                key={index}
                                variants={itemVariants}
                                className="bg-white p-6 rounded-xl shadow-lg hover:shadow-2xl transition duration-300 transform hover:scale-[1.02] border-t-4 border-red-600"
                            >
                                <div className="flex items-center mb-4">
                                    <Icon className={`w-8 h-8 ${feature.color} mr-4`} />
                                    <h3 className="text-xl font-bold text-gray-900">{feature.name}</h3>
                                </div>
                                <p className="text-gray-600">{feature.description}</p>
                            </motion.div>
                        );
                    })}
                </motion.div>
            </div>
        </section>
    );
};

export default ServiceHighlights;